  <template>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <b-tabs v-model="tab" @input="onTabChange">
              <b-tab :title="'مقارئ الطالب'">
                <Datatable :editItem="editItem" ref="datatable" :type="type"></Datatable>
              </b-tab>
              <b-tab v-if="type == 'teacher'" @click="newItem = {}" title="َاضافة ورد جديد">
                <Form :newItem="newItem" ref="formComponent"></Form>
              </b-tab>
            </b-tabs>
          </div>
          <!-- end of card body -->
        </div>
        <!-- end of card -->
      </div>
      <!-- end of col -->
    </div>
  </template>


<script>
import Datatable from "./components/QuranScheduleSystemic/v2/datatable.vue";
import Form from "./components/QuranScheduleSystemic/v2/form.vue";
import AUTH from "@/Apis/Auth";
export default {
  name: "QuranScheduleDateSystemic",
  components: {
    Datatable,
    Form
  },
  computed:{
    type(){
      return AUTH.USER.account_type;
    }
  },
  data() {
    return {
      tab: 0,

    };
  },
  methods: {
    onTabChange() {
      if (this.tab === 1) {
        this.$refs.formComponent.checkCompleted();
      }else{
        this.$refs.datatable.refresh();
      }
    }
  }
}
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
<style scoped>
[dir] .demo-inline-spacing>* {
  margin-top: 0px !important;
}
</style>
